export enum ServiceType {
    FedExGround = 1,
    PriorityOvernight = 2,
    InternationalPriority = 3,
    FedExFreightPriority = 4,
    FedExFreightEconomy = 5,
}

export enum FedExShipmentType {
    Ltl = 1,
    Parcel = 2,
}

export interface FedExShipmentViewModel {
    shipmentId: string;
    shipmentType: FedExShipmentType;
    serviceType: ServiceType;
}

export interface FedExShipmentResponseViewModel {
    trackingNumber?: string | null;
}
